// ** Dropdowns Imports
import UserDropdown from './UserDropdown'

// ** Third Party Components
import { Sun, Moon, Menu, Bell } from 'react-feather'
import { NavItem, NavLink } from 'reactstrap'
import LangDropdown from '@components/navbar/LangDropdown'
import { isCandidate } from '@services/authentificationServices'
import { Link } from 'react-router-dom'
import './style.scss'
import Media from 'react-media'

const NavbarUser = props => {
  // ** Props
  const { skin, setSkin, setMenuVisibility } = props

  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === 'dark') {
      return <Sun className='ficon' onClick={() => setSkin('light')} />
    } else {
      return <Moon className='ficon' onClick={() => setSkin('dark')} />
    }
  }

  const appLogoImage = require('@src/assets/images/logo/logo VJ_#d91d0b_1 1.png').default;

  return (
    <>
      <ul className='navbar-nav d-xl-none d-flex align-items-center'>
        <NavItem className='mobile-menu mr-auto'>
          <NavLink className='nav-menu-main menu-toggle hidden-xs is-active' onClick={() => setMenuVisibility(true)}>
            <Menu className='ficon' />
          </NavLink>
        </NavItem>
      </ul>
      <div className='bookmark-wrapper d-flex align-items-center'>
        <NavItem className='d-flex'>
          <NavLink className='nav-link-style'>
            <ThemeToggler />
          </NavLink>
        </NavItem>
      </div>

      {
        
          <Media queries={{ small: '(max-width: 1199px)' }}>
            {matches => (
              <div className='full-width'>
                {matches.small && (
                  <div className='nav navbar-nav justify-content-center align-items-center ml-auto'>
                    <Link to={'/'} className='position-relative'>
                      <span className='brand-logo'>
                        <img src={appLogoImage} height={40} alt='logo' className='brand-logo' />
                      </span>
                    </Link>
                  </div>
                )}
              </div>
            )}
          </Media>
      }

      {/* {
        !isCandidate() && (
          <Media queries={{ medium: '(max-width: 1199px)' }}>
            {matches => (
            <div className='full-width'>
                {matches.medium && (
                  <div className='nav navbar-nav justify-content-center align-items-center ml-auto'>
                    <Link to={'/'} className='position-relative'>
                      <span className='brand-logo'>
                        <img src={appLogoImage} height={40} alt='logo' className='brand-logo' />
                      </span>
                    </Link>
                  </div>
                )}
              </div>
            )}
          </Media>
        )
      } */}

      {
        !isCandidate() && (
          <div className='nav navbar-nav justify-content-center align-items-center ml-auto'>
            <Link to={'/notifications'} className='position-relative'>
              <div className='puce-notifications'></div>
              <Bell size={24} className='cursor-pointer' color='#6E6B7B' />
            </Link>
          </div>
        )
      }
      <ul className={`nav navbar-nav justify-content-center align-items-center ${isCandidate() ? 'ml-auto' : 'ml-2'}`}>
        <LangDropdown />
      </ul>
      <ul className='nav navbar-nav align-items-center ml-50'>
        <UserDropdown />
      </ul>
    </>
  )
}
export default NavbarUser
